import React, { Component } from "react";
import { Calendar } from "./Calendar/Calendar";

export class Salary extends Component {
  render() {
    return (
      <>
        <div>
          <Calendar></Calendar>
        </div>
      </>
    );
  }
}
